import { Attachment } from '@/classes/models'

export default class Ticket {
  /**
   * Create new ticket and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map attachments to attachments if there are attachments
    this.attachments = typeof this.attachments !== 'undefined' ? this.attachments.map(attachment => new Attachment({ ...attachment, reference: attachment.ticketAttachmentId })) : []
    this.allAttachments = typeof this.allAttachments !== 'undefined' ? this.allAttachments.map(attachment => new Attachment({ ...attachment, reference: attachment.ticketAttachmentId })) : []
  }

  /**
   * @return {Date}
   */
  get createdUtc () {
    return this._createdUtc
  }

  /**
   * @param {string} value
   */
  set createdUtc (value) {
    this._createdUtc = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get lastUpdatedUtc () {
    return this._lastUpdatedUtc
  }

  /**
   * @param {string} value
   */
  set lastUpdatedUtc (value) {
    this._lastUpdatedUtc = value ? new Date(value) : null
  }
}
